import { BaseComponent, IStateBase } from 'components/BaseComponent';
import React from 'react';
import Dialog from '@material-ui/core/Dialog/Dialog';
import YoutubeEmbed from 'components/YoutubeEmbed/index';
import { cartService } from 'services/CartService';
import DialogTitle from '@material-ui/core/DialogTitle/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent/DialogContent';
import DialogActions from '@material-ui/core/DialogActions/DialogActions';
import { showAlert } from 'shared/services/dialog';
import Close from '@material-ui/icons/Close';
import { enPaymentType } from 'enums/enPaymentType';
import { getCdnImage } from 'functions';
import { IProductData } from 'interfaces/IProductData';
import Fab from '@material-ui/core/Fab';
import { exitPopUpService } from 'services/ExitPopUpService';

const style = require('./exitPopUp.css');

interface IState extends IStateBase {
  cart: IProductData;
  open: boolean;
  timerMinutes: string;
  timerSeconds: string;
}

export default class ExitPopUp extends BaseComponent<IState, {}> {

  constructor(props: any) {
    super(props);
    this.state = {
      open: false,
      timerMinutes: '',
      timerSeconds: '',
      cart: null
    };
  }

  componentDidMount() {
    this.observeState({ cart: null }, cartService.getCart());

    exitPopUpService.verifyTimer()
      .bindComponent(this)
      .subscribe(registredValue => {
        this.handleClickOpen();
        this.setTimer(registredValue);
      });

    exitPopUpService.mouseEvent()
      .bindComponent(this)
      .subscribe((registredValue) => {
        this.handleClickOpen();
        this.setTimer(registredValue);
      });
  }

  setTimer = (registredValue: any) => {
    const clock = setInterval(() => {

      let actualValue: any = new Date().getTime();
      let finalValueMinutes = ((registredValue - actualValue) / 1000) / 60;
      let finalValueSeconds = ((((registredValue - actualValue) / 1000) / 60) - Math.trunc(finalValueMinutes)) * 60;

      this.setState({
        timerMinutes: ('0' + Math.floor(finalValueMinutes)).slice(-2),
        timerSeconds: ('0' + finalValueSeconds.toFixed(0)).slice(-2)
      });

      if (parseInt(this.state.timerMinutes) <= 0 && parseInt(this.state.timerSeconds) <= 0) {
        this.setState({ open: false });
        clearInterval(clock);
      }

    }, 1000);
  }

  handleClickOpen = () => {
    this.setState({ open: true });

    window.requestAnimationFrame(() => {
      const audio: HTMLAudioElement = document.querySelector('#audioModal');

      if (!audio) {
        return;
      }

      try {
        audio.play();
      } catch (err) {
        console.log('browser bloqueou a execução do audio');
      }
    });
  }

  handleClose = () => {
    this.setCoupon();
    this.setState({ open: false });
  }

  setCoupon = () => {

    const coupon = this.state.cart.config.exitModal && this.state.cart.config.exitModal.coupon || null;

    if (!coupon) {
      return;
    }

    cartService.setCoupon(this.state.cart.config.exitModal.coupon, 2)
      .catch(err => {
        return showAlert('Ocorreu um erro ao aplicar o seu cupom, tente novamente')
          .map(() => false);
      })
      .bindComponent(this)
      .subscribe();
  }

  render() {

    if (!this.state.cart) {
      return null;
    }

    const { cart } = this.state;

    return (
      <div>

        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
          className={style.component}
        >
          <Fab
            id='chk-exitpopup-close-button'
            size='small'
            className='close-icon'
            color='default'
            aria-label='Fechar'
            onClick={this.handleClose}
          >
            <Close />
          </Fab>
          <DialogTitle
            className='chk-dialog-header theme-exit-pop-up-header'
          >
            <span className='theme-exit-pop-up-title'>
              {cart.config.exitModal.timer.theme.title}
            </span>
            {cart.config.exitModal.timer.enabled ?
              <div className='theme-exit-pop-up-timer'>
                {this.state.timerMinutes}
                :
            {this.state.timerSeconds}
              </div>
              : null
            }
          </DialogTitle>
          <DialogContent className='chk-dialog-text'>

            {cart.config.exitModal.media.video ?
              <YoutubeEmbed url={cart.config.exitModal.media.video} />
              : <img className='chk-img-modal' src={getCdnImage(cart.config.exitModal.media.image)} />
            }
            {cart.config.exitModal.media.audio ?
              <audio id='audioModal'>
                <source type='audio/mpeg' src={cart.config.exitModal.media.audio} />
              </audio>
              : null
            }

          </DialogContent>
          <DialogActions className='chk-btn-action'>
            {cart.config.exitModal.button.enabled && cart.paymentType !== enPaymentType.FREE ?
              <button
                id='chk-exitpopup-button'
                className={'btn-receive-discount theme-exit-pop-up-button'}
                onClick={this.handleClose}
              >
                {cart.config.exitModal.button.theme.text}
              </button>
              : ''
            }
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ExitPopUp/index.tsx